import React from 'react';
import {useLocation, Link} from 'react-router-dom';
import {useAuth} from '@/contexts/AuthContext.jsx';
import {useLanguage} from '@/contexts/LanguageContext.jsx';
import {getSupabaseRuntimeConfig} from '@/services/supabaseClient.js';
import {logout} from '@/lib/auth/logout';
import {isProductionReleaseContext, isStagingAdminRoute, productionLaunchBoundary} from '@/lib/productionLaunchScope.mjs';
import ProductionCurrentUserAdmission from './ProductionCurrentUserAdmission.jsx';
import ProductionOrganisationAdmission from './ProductionOrganisationAdmission.jsx';
import {organisationLaunchLane} from '@/lib/organisationLaunchLane.mjs';

export default function ProductionLaunchGate({children}) {
  const {user} = useAuth() || {};
  const {languageCode} = useLanguage();
  const {pathname} = useLocation();
  const releaseContext = {
    appEnv: import.meta.env.VITE_APP_ENV,
    hostname: typeof window === 'undefined' ? '' : window.location.hostname,
    reviewMode: import.meta.env.VITE_OPTION_B_REVIEW === 'true',
  };
  const runtimeConfig = getSupabaseRuntimeConfig();
  if (isStagingAdminRoute({hostname: releaseContext.hostname, pathname, runtimeSource: runtimeConfig.source})) return children;
  const boundary = productionLaunchBoundary({...releaseContext,supabaseUrl:runtimeConfig.url,pathname});
  if (!boundary) {
    if (!isProductionReleaseContext(releaseContext) || !user || pathname.startsWith('/auth/')) return children;
    const lane = organisationLaunchLane(pathname);
    const content = lane ? <ProductionOrganisationAdmission lane={lane}>{children}</ProductionOrganisationAdmission> : children;
    return <ProductionCurrentUserAdmission userId={user.id}>{content}</ProductionCurrentUserAdmission>;
  }
  const fr = String(languageCode).startsWith('fr');
  return <main className="min-h-[100dvh] grid place-items-center bg-background px-6 text-center">
    <section className="max-w-md space-y-4">
      <h1 className="text-title-large">{fr ? 'Accès AfriMed™' : 'AfriMed™ access'}</h1>
      <p>{boundary === 'admission'
        ? (fr ? 'L’accès est actuellement réservé aux comptes invités.' : 'Access is currently limited to invited accounts.')
        : (fr ? 'Ce service n’est pas disponible pendant le lancement initial.' : 'This service is not available during the initial launch.')}</p>
      {boundary === 'admission'
        ? <button type="button" className="text-primary" onClick={() => logout({redirectTo:'/login?logout=1'})}>{fr ? 'Se déconnecter' : 'Sign out'}</button>
        : <Link className="text-primary" to="/">{fr ? 'Retour à l’accueil' : 'Back to home'}</Link>}
    </section>
  </main>;
}
